export const mammoQualityControlArtifactEvaluationDetails = {
    template: require('./mammo-quality-control-artifact-evaluation-details.html'),
    controller: 'MammoQualityControlArtifactEvaluationDetailsController'
};
